import { ReactNode } from 'react';
import LandingPageHeader from '../landing/LandingPageHeader';
import Footer from '../footer';

interface LandingPageLayoutProps {
  children: ReactNode;
}

const LandingPageLayout = ({ children }: LandingPageLayoutProps) => {
  const topPaddingClasses = 'pt-[64px] desktopNav:pt-[72px]';

  return (
    <div className='flex flex-col min-h-screen mx-auto'>
      <LandingPageHeader />
      <main className='grow'>
        <div className={`mx-auto ${topPaddingClasses}`}>{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default LandingPageLayout;
